module.exports = __webpack_public_path__ + "img/logo_popol_vuh_black.d1f0a4d5.png";